<template>

	<div class="min-h-full">
		<nav class="bg-white relative shadow z-20">
			<app-header :auth="$attrs.auth" :fixed-width-header="false"/>
		</nav>


		<!-- new slide modal -->
<!--		<transition enter-active-class="ease-out duration-200" enter-class="opacity-0" enter-to-class="opacity-100"-->
<!--					leave-active-class="ease-in duration-100" leave-class="opacity-100" leave-to-class="opacity-0">-->
<!--			<div v-if="newSlideModalOpen">-->
<!--				<add-new-slide :collections="props.collections"-->
<!--							   :activeCollection="props.activeCollection"-->
<!--							   :tags="props.tags"-->
<!--							   :open=newSlideModalOpen-->
<!--							   @close="newSlideModalOpen = false"-->
<!--				/>-->
<!--			</div>-->
<!--		</transition>-->




		<main class="relative">
<!--			<div class="relative z-10 lg:px-8 max-w-7xl mx-auto px-4 py-6 sm:px-6">-->
			<div class="relative z-10 lg:px-8 mx-auto px-4 py-6 sm:px-6">
				<slide-gallery @newSlide="newSlideModalOpen = true"
							   :slides="props.slides"
							   :meta="props.activeCollection"
							   :collections="props.collections"
							   :tags="props.tags"
							   :pendingSlides="props.pendingSlides"
							   :pendingSlidesCount="props.pendingSlidesCount"
							   :auth="$attrs.auth"/>
			</div>

			<!-- checkered background lines -->
			<div
				class="absolute inset-0"
				style="mask-image:linear-gradient(to bottom, transparent, black 30%);-webkit-mask-image:linear-gradient(to bottom, transparent, black 30%); min-height: calc(100vh - 64px);
				background-image: url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2032%2032%22%20width%3D%2232%22%20height%3D%2232%22%20fill%3D%22none%22%20stroke%3D%22rgb%2815%2023%2042%20%2F%200.04%29%22%3E%3Cpath%20d%3D%22M0%20.5H31.5V32%22%2F%3E%3C%2Fsvg%3E);"
			>
			</div>

		</main>
	</div>

</template>


<script setup>
import {computed, reactive, ref, onMounted} from "vue";
import AppHeader from "@/Layouts/AppHeader";


import {Link, useForm} from '@inertiajs/vue3'
import AddNewSlide from "@/Pages/SlideRepo/Modals/AddNewSlide_OLD";
import { router } from '@inertiajs/vue3';
import SlideGallery from "@/Pages/SlideRepo/SlideGallery";

const newSlideModalOpen = ref(false);
const newCollectionDuplicateWarning = ref(false);
let collectionListOpen = ref(false);


const props = defineProps({
	collections: {type: Object},
	activeCollection: {type: Object},
	slides: {type: Object},
	tags: {type: Object},
	pendingSlides: {type: Object},
	pendingSlidesCount: {type: Number}
});

onMounted(() => {

	// set the active collection, so I can use this if I need it
	let url = window.location.href
	let activeCollection = url.substr(url.lastIndexOf('/') + 1);
	localStorage.setItem('activeCollection', activeCollection)

});



</script>
